import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Crown, Sparkles } from 'lucide-react';

/**
 * PaywallOverlay Component
 * Creates a frosted/blurred overlay with a call-to-action for premium features
 */
export const PaywallOverlay = ({ 
  children, 
  isPaid = false, 
  message = "Upgrade to Premium to unlock this feature",
  className = ""
}) => {
  const navigate = useNavigate();

  if (isPaid) {
    return <>{children}</>;
  }

  return (
    <div className={`relative ${className}`}>
      {/* Blurred Content */}
      <div className="blur-sm pointer-events-none select-none">
        {children}
      </div>

      {/* Frosted Overlay */}
      <div className="absolute inset-0 bg-white/60 backdrop-blur-md flex items-center justify-center p-6">
        <div className="text-center max-w-md">
          <div className="mb-4 flex justify-center">
            <div className="bg-gradient-to-r from-yellow-500 to-orange-500 p-4 rounded-full">
              <Crown className="h-12 w-12 text-white" />
            </div>
          </div>
          
          <h3 className="text-2xl font-bold mb-3 text-gray-900">
            Premium Feature
          </h3>
          
          <p className="text-gray-700 mb-6">
            {message}
          </p>

          <Button
            onClick={() => navigate('/subscription')}
            className="bg-gradient-to-r from-purple-600 to-indigo-600 hover:from-purple-700 hover:to-indigo-700 text-white px-8 py-6 text-lg"
          >
            <Sparkles className="mr-2 h-5 w-5" />
            Upgrade to Premium
          </Button>

          <p className="text-sm text-gray-600 mt-4">
            Unlock unlimited sessions, advanced features, and more
          </p>
        </div>
      </div>
    </div>
  );
};

export default PaywallOverlay;
